export const RECEIVE_PARTNERS_LINK = 'RECEIVE_PARTNERS_LINK';
export const GET_PARTNER_LINK = 'GET_PARTNER_LINK';
